import { makeStyles } from '@material-ui/core';
import { colors } from '../../common/colors';
import { sizes } from './DatePicker';

export const useStyles = makeStyles(theme => ({
    label: ({ size }) => ({
        color: colors.gray.gray06,
        fontWeight: 'bold',
        fontSize: size === sizes.large ? '14px' : '12px',
        marginBottom: '4px',
        fontFamily: theme.typography.fontFamily,
        '& > span': {
            fontSize: '11px',
            fontWeight: 400,
            color: colors.gray.gray05,
        }
    }),
    helperText: ({ size }) => ({
        color: colors.gray.gray06,
        fontSize: size === sizes.large ? '13px' : '11px',
        marginTop: '4px',
        fontFamily: theme.typography.fontFamily,
    }),
    textField: ({open, size}) => ({
        '&.MuiInputBase-input':{
            height:'2.125rem'
        },
        '&.MuiOutlinedInput-input': {
            color: colors.gray.gray05,
        },
        '&.MuiFormControl-root': {
            width: '100%',
            background: colors.white,
            '& > .MuiInputBase-root': {
                fontSize: '14px'
            },
        },
        '& > .MuiInputBase-root': {
            height: size === sizes.large ? '3.125rem' : '2.375rem',
            color: colors.gray.gray07,
            '& > fieldset': {
                border: `1px solid ${open ? colors.primary.default : colors.gray.gray04}`,
            },
            '&:hover fieldset': {
                border: `1px solid ${colors.gray.gray07}`,
            },
            '&.Mui-focused > fieldset': {
                border: `1px solid ${colors.primary.default}`,
            },
            '&.Mui-disabled': {
                background: colors.gray.gray02,
                color: colors.gray.gray05,
                '& fieldset': {
                    border: `1px solid ${colors.gray.gray04}`,
                }
            },
            '&.Mui-error fieldset': {
                border: `1px solid ${colors.error.default}`
            },
            '& > .MuiInputAdornment-root': {
                padding: size === sizes.large ? '4px' : 'none',
            },
            "& input": {
                "&::placeholder": {
                    color: colors.gray.gray05,
                },
            },
        },
    }),
    textFieldMobile: ({disabled}) => ({
        position: 'relative',
        '& > span': {
            position: 'absolute',
            top: -38,
            right: 0,
            color: disabled ? 'rgba(0, 0, 0, 0.26)' : colors.gray.gray06,
            padding: '10px 14px',
        },
        '& > input': {
            padding: '1em !important',
            margin: '0 !important',
            position: 'absolute',
            left: '-9999px',
            top: '-9999px',
            width: '1px',
            height: '1px',
            overflow: 'hidden'
        }
    })
}))

export const popperStyles = {
    '& .MuiPaper-root': {
        marginLeft: '36px',
        marginTop: '3px'
    },
    '& .MuiPickersCalendarHeader-label': {
        fontWeight: 600,
        color: colors.gray.gray07,
    },
    '& .MuiTypography-root': {
        fontSize: '14px',
        fontFamily: '"Open Sans", Roboto, sans-serif',
    },
    '& .MuiSvgIcon-root': {
        fontSize: '18px',
        color: colors.gray.gray06,
    },
    '& .Mui-selected': {
        background: `${colors.gray.gray03} !important`,
        color: `${colors.gray.gray07} !important`,
        fontWeight: '600 !important',
        fontSize: '14px',
        fontFamily: '"Open Sans", Roboto, sans-serif',
    },
    '& .Mui-disabled': {
        color: `${colors.gray.gray05} !important`,
        background: colors.white,
    },
    '& .MuiPickersDay-today': {
        border: '0 !important',
        background: colors.gray.gray02,
        color: `${colors.gray.gray07} !important`,
        fontWeight: 600,
        fontSize: '14px',
        fontFamily: '"Open Sans", Roboto, sans-serif',
    },
    '& .MuiPickersDay-root': {
        borderRadius: '5px',
        fontFamily: '"Open Sans", Roboto, sans-serif',
    },
    '& .MuiPickersDay-root:hover': {
        background: colors.gray.gray02,
    },
    '& .MuiButtonBase-root': {
        color: colors.gray.gray07,
        fontSize: '14px',
        fontFamily: '"Open Sans", Roboto, sans-serif',
    },
    '& .PrivatePickersYear-yearButton': {
        borderRadius: '5px',
    },
    '& .PrivatePickersYear-yearButton:focus': {
        outline: 'none',
    },
    '& .PrivatePickersMonth-root': {
        borderRadius: '5px',
    },
    '& .PrivatePickersMonth-root:focus': {
        outline: 'none',
    },
    '& .MuiPickersCalendarHeader-root': {
        textTransform: 'capitalize',
        '& div > div > .MuiPickersCalendarHeader-label': {
            fontFamily: '"Open Sans", Roboto, sans-serif',
            fontSize: '14px',
        },
        '& .MuiPickersArrowSwitcher-spacer': {
            width: '0.7rem',
        }
    },
    '& .MuiPickersFadeTransitionGroup-root > div > .MuiYearPicker-root > div > button': {
        fontFamily: '"Open Sans", Roboto, sans-serif',
        fontSize: '14px',
        margin: '0.3125rem 0',
    }
}
